<template>
    <div class="memDetails">
        <div class="myavatar" :class="{'eravatar' :$store.state.userInfo.brandId == 2 }"><img src="../../assets/images/store/img_avatar_default.png" alt=""> 会员头像</div>
        <el-form ref="form" :model="form">
            <el-row>
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>会员姓名</span></label><span class="point">{{form.name}}</span>
                </el-col>
                <el-col :span="6">
                    <label><span>称呼</span></label>{{form.sex == 1 ? '先生' : '女士'}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>联系方式</span></label>{{form.phone}}
                </el-col>
                <el-col :span="6" v-if="$store.state.userInfo.brandId == 1">
                    <label><span>生日</span></label>{{form.memberBirth | formatDateMon}}
                </el-col>
                <!-- <el-col :span="6" v-else>
                    <label><span>关系</span></label>{{form.sex == 1 ? '爸爸' : '妈妈'}}
                </el-col> -->
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <div v-if="$store.state.userInfo.brandId == 1">
                <el-row>
                    <el-col :span="6"><div class="seize"></div></el-col>
                    <el-col :span="7">
                        <label><span>年龄</span></label>{{form.age ? form.age + ' 岁' : ''}}
                    </el-col>
                    <el-col :span="6">
                        <label><span>身高</span></label>{{(form.health && form.health.height) ? form.health.height + ' cm' : ''}}
                    </el-col>
                    <el-col :span="5"><div class="seize"></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><div class="seize"></div></el-col>
                    <el-col :span="7">
                        <label><span>职业</span></label>{{form.occupation}}
                    </el-col>
                    <el-col :span="6">
                        <label><span>体重</span></label>{{(form.health && form.health.weight) ?　form.health.weight + ' kg' : ''}}
                    </el-col>
                    <el-col :span="5"><div class="seize"></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><div class="seize"></div></el-col>
                    <el-col :span="7">
                        <label><span>血型</span></label>{{(form.health && form.health.bloodType) ?　form.health.bloodType : ''}}
                    </el-col>
                    <el-col :span="6">
                        <label><span>生产日期</span></label>{{(form.health && form.health.dueDate) | formatDateYear}}
                    </el-col>
                    <el-col :span="5"><div class="seize"></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><div class="seize"></div></el-col>
                    <el-col :span="7">
                        <label><span>孩子1出生日期</span></label>{{(form.childList && form.childList.length > 0?form.childList[0].childBirth :'') | formatDateMon}}
                    </el-col>
                    <el-col :span="6">
                        <label><span>孩子2出生日期</span></label>{{(form.childList && form.childList.length > 1?form.childList[1].childBirth:'')| formatDateMon}}
                    </el-col>
                    <el-col :span="5"><div class="seize"></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><div class="seize"></div></el-col>
                    <el-col :span="7">
                        <label><span>结婚纪念日</span></label>{{form.weddingDay | formatDateMon}}
                    </el-col>
                </el-row>
            </div>
            <el-row class="borTop">
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>昵称</span></label>{{form.alias}}
                </el-col>
                <el-col :span="6" v-if="$route.params.id">
                    <label><span>积分余额</span></label>{{form.accountOffList.pointsOff ? form.accountOffList.pointsOff : '' - form.accountOffList.consumedPointsOff ? form.accountOffList.consumedPointsOff : ''}}
                </el-col>
                <el-col :span="6" v-else>
                    <label><span>注册来源</span></label>{{form.source | filterSource}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row v-if="$route.params.id">
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>注册来源</span></label>{{form.source | filterSource}}
                </el-col>
                <el-col :span="6">
                    <label><span>账户余额</span></label>{{form.accountOffList.accountOff}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>个人邀请码</span></label>{{form.inviteCode}}
                </el-col>
                <el-col :span="6">
                    <label><span>累计佣金</span></label>{{form.account &&　form.account.commisionTotal}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>邀请人</span></label>无
                </el-col>
                <el-col :span="6">
                    <label><span>累计线上充值</span></label>{{form.account && form.account.rechargeTotal}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="7">
                    <label><span>openID</span></label>{{form.openId}}
                </el-col>
                <el-col :span="6" v-if="$route.params.id">
                    <label><span>累计门店充值</span></label>{{form.accountOffList.rechargeTotalOff}}
                </el-col>
                <el-col :span="5"><div class="seize"></div></el-col>
            </el-row>
            <el-row class="borTop">
                <el-col :span="6"><div class="seize"></div></el-col>
                <el-col :span="18">
                    <label style="float:left"><span>个人服务</span></label>
                    <template v-if="!serviceProList">
                        <span>--</span>
                    </template>
                    <template v-else-if="serviceProList.length > 0">
                        <el-col :span="20" class="serviceprolists">
                            <table>
                                <tr v-for="(i,index) in serviceProList" :key="index">
                                    <td>{{i.serviceName}}</td>
                                    <td>
                                        <span v-if="i.courseStyle && i.courseStyle == 1">可用次数<span class="red">{{i.serviceLeftCount - i.serviceLockCount}}</span></span>
                                        <span v-else-if="i.courseStyle && i.courseStyle == 2">截止<span class="red">{{i.serviceEndDate}}</span></span>
                                        <span v-else>--</span>
                                    </td>
                                    <td>
                                        <span>进行中<span class="red">{{i.serviceLockCount}}</span></span></span>
                                    </td>
                                </tr>
                            </table>
                        </el-col>
                    </template>
                    <template v-else>
                        <span class="red" style="line-height: 32px">抱歉！暂无剩余项目</span>
                    </template>
                </el-col>
            </el-row>
            <el-row class="borTop" v-if="$store.state.userInfo.brandId == 1">
                <!-- 婷美 -->
                <div class="topTab">健康档案</div>
                <el-table :data="healthData" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
                    <el-table-column align="center" prop="matter" label="事项"></el-table-column>
                    <el-table-column align="center" prop="condition" label="具体情况"></el-table-column>
                </el-table>
                <!-- <el-table
                    :data="[form.health]"
                    border
                    style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
                    <el-table-column align="center" prop="shape" label="体型" width="80">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.shape | filterShape | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="procreate" label="所属阶段">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.procreate | filterProcreate}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="menstrual" label="月经周期">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.menstrual | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="expectedDate" label="预产/生产日期" width="130">
                        <template slot-scope="scope">
                            <span v-if="scope.row && scope.row.procreate == 2">
                                {{scope.row.dueDate | formatDateYear | filterRow}}
                            </span>
                            <span v-else-if="scope.row && scope.row.procreate == 1">
                                {{scope.row.expectedDate | formatDateYear |　filterRow}}
                            </span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="lactation" label="哺乳时长">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.lactation | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="dueStyle" label="生产方式" width="90">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.dueStyle | filterDueStyle |　filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="organList" label="需改善部位">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.organList | filterOrgan(MemPatrs)}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remarks" label="备注" width="200">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.remarks | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="creator" label="记录人">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.creator | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="createTime" label="记录时间" width="150">
                        <template slot-scope="scope">
                            {{scope.row && scope.row.createTime | formatDateLine | filterRow}}
                        </template>
                    </el-table-column>
                </el-table> -->
            </el-row>
            <el-row class="borTop" v-else v-for="(i,index) in form.childList" :key="index">
                <!-- 儿推孩子信息 -->
                <el-row class="myChilds" >
                    <el-col :span="6" class="title">孩子{{index + 1}} 信息</el-col>
                    <el-col :span="5" style="position:relative">
                        <label><span>姓名</span></label><span class="point childTit">{{i.childName}}</span>
                    </el-col>
                    <el-col :span="4">
                        <label><span>性别</span></label>{{i.childSex == 1 ? '男':'女'}}
                    </el-col>
                    <el-col :span="5">
                        <label><span>生日</span></label>{{i.childBirth | formatDateYear}}
                    </el-col>
                </el-row>
                <div class="topTab">健康档案</div>
                <el-table
                    :data="[i.health]"
                    border
                    style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
                    <el-table-column align="center" prop="height" label="身高">
                        <template slot-scope="scope">
                            {{scope.row.height ? (scope.row.height +' cm') : '--'}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="weight" label="体重">
                        <template slot-scope="scope">
                            {{scope.row.weight ? (scope.row.weight+' Kg'):'--'}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="relationship" label="关系">
                        <template slot-scope="scope">
                            {{scope.row.relationship | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="taboo" label="是否有禁忌症">
                        <template slot-scope="scope">
                            {{scope.row.taboo ==1 ? '有':'无'}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="develop" label="发育情况" width="100">
                        <template slot-scope="scope">
                            {{scope.row.develop | filterDevelop | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="develop" label="缓解症状" width="100">
                        <template slot-scope="scope">
                            {{scope.row.develop | filterDevelop | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remarks" label="备注">
                        <template slot-scope="scope">
                            {{scope.row.remarks | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="creator" label="记录人">
                        <template slot-scope="scope">
                            {{scope.row.creator | filterRow}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="createTime" label="记录时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime | formatDateLine | filterRow}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <el-form-item class="btnOptions">
                <el-button class="darkBtn" @click="closeTab">关闭</el-button>
                <el-button class="redBtn" @click="insertMem" v-if="this.$route.params.phone">加入本店会员</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { searchOrgan, memDetail, memberServiceList, insertAccount } from "@/api";
import { formatDate } from '@/components/common/js/date.js';
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      form: {
        account: {},
        accountOffList: {},
        health: {},
        childList: [
          {
            childName: "",
            childSex: '1',
            childBirth: "",
            health: {
              height: "",
              weight: "",
              develop: "",
              remarks: ""
            }
          }
        ]
      },
      serviceProList:'',
      MemPatrs: []
    };
  },
  watch: {
    '$route.params.id' (val){
        if(val){
            this.part();
            this.detailInfo();
        }
    }
  },
  computed: {
      healthData(){
          let data = [];
          if(this.form.health){
              let skinStatus = [],shapeName=[],foodName=[],breastStatus=[],symptomsName=[]
              if(this.form.health.skins){
                for(let list of this.form.health.skins){
                    skinStatus.push(list.skinStatus)
                }
              }
              if(this.form.health.shapes){
                for(let list of this.form.health.shapes){
                    shapeName.push(list.shapeName)
                }
              }
              if(this.form.health.foods){
                for(let list of this.form.health.foods){
                    foodName.push(list.foodName)
                }
              }
              if(this.form.health.breasts){
                for(let list of this.form.health.breasts){
                    breastStatus.push(list.breastStatus)
                }
              }
              if(this.form.health.symptoms){
                for(let list of this.form.health.symptoms){
                    symptomsName.push(list.symptomsName)
                }
              }
              data.push(
                {
                    matter:'皮肤状态',
                    condition:skinStatus.length > 0 ?skinStatus.join('，'):'无'
                },{
                    matter:'体型',
                    condition:shapeName.length > 0 ?shapeName.join('，'):'无'
                },{
                    matter:'经常食用以下类型食物',
                    condition:foodName.length > 0?foodName.join('，'):'无'
                },{
                    matter:'吃早餐的习惯',
                    condition:this.form.health.breakfast == 1 ?'有':'无'
                },{
                    matter:'吃夜宵的习惯',
                    condition:this.form.health.snack == 1?'有':'无'
                },{
                    matter:'经常入睡时间',
                    condition:this.form.health.bedtime == 1?'23点前':'23点后'
                },{
                    matter:'睡眠时间',
                    condition:this.form.health.sleepTime == 1?'8小时以下':(this.form.health.sleepTime == 2?'8小时以上':'8小时')
                },{
                    matter:'服务减肥药品/食品',
                    condition:this.form.health.eatDietFood == 1?'有 ' + (this.form.health.dietFood):'无'
                },{
                    matter:'月经期是否规律',
                    condition:this.form.health.menstrualNormal == 1?'是' :'否 '+(this.form.health.menstrualContent)
                },{
                    matter:'乳房情况',
                    condition:breastStatus.length > 0?breastStatus.join('，'):'无'
                },{
                    matter:'以下症状有无',
                    condition:symptomsName.length > 0?symptomsName.join('，'):'无'
                })
          }
          return data;
      }
  },
  created() {
    this.part();
    this.detailInfo();
  },
  methods: {
    part() {
      searchOrgan().then(res => {
        this.MemPatrs = res.data;
      });
    },
    detailInfo() {
      memDetail({
        memberId : this.$route.params.id ? this.$route.params.id : '',
        phone: this.$route.params.phone ? this.$route.params.phone : ''
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          this.form.accountOffList = res.data.accountOffList[0];
          this.form.account = res.data.account;
          this.form.health = res.data.health;
          if (this.$store.state.userInfo.brandId != 1) {
            this.form.childList = res.data.childList;
            if(res.data.childList){
                for(let i of res.data.childList){
                    if(!i.health){
                        i.health = Object.assign(
                        {},
                        this.$options.data().form.childList.health
                        );
                    }
                }
            }
          }
          memberServiceList({
                memberId:res.data.memberId
            }).then(lastRes => {
                this.serviceProList = lastRes.data;
                for(let i of this.serviceProList){
                    i.serviceEndDate = formatDate(i.serviceEndDate, 'yyyy-MM-dd');
                }
            })
        }else{
            this.form = this.$options.data().form;
        }
      });
    },
    closeTab() {
      // 关闭会员详情页返回列表页
      this.$store.commit("delete_tabs", this.$route.path);
      this.$store.commit("setAliveStatus", true);//保留列表页状态
      this.$router.push("/basicDataCenter/baseInfo");
    },
    insertMem(){
        // 加入本店会员
        insertAccount({
            memberId:this.form.memberId
        }).then(res=>{
            if (res.code == 1) {
                sessionStorage.setItem("memId", this.form.memberId);
                // 进入消费密码设置页
                // this.$router.push("/basicDataCenter/setPsd");
                this.$store.commit("setAliveStatus", true);//保留列表页状态
                this.$router.push("/basicDataCenter/baseInfo");
            }
            this.$message({
                type: res.code == 1 ? "success":'error',
                message: res.msg
            });
        })
    }
  }
};
</script>
<style lang="less" scoped>
.memDetails {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  position: relative;
  .myavatar {
    width: 76px;
    position: absolute;
    top: 440px;
    left: 165px;
    text-align: center;
    color: #666;
    &.eravatar{
        top: 220px;
    }
    img {
      width: 100%;
    }
  }
  .myChilds {
    .title {
      color: #444;
      font-size: 17px;
      font-weight: bold;
      text-align: center;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .point {
    color: #f83b56;
    font-size: 17px;
    font-weight: bold;
    line-height: 30px;
    &.childTit{
        width: 100%;
        line-height: 25px;
        position: absolute;
        left: 0;
        padding-left: 100px;
    }
  }
  .topTab {
    width: 95px;
    height: 38px;
    line-height: 38px;
    background: #3b404f;
    border-radius: 15px 15px 0px 0px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
  }
  .serviceprolists{
      display: inline-block;
      vertical-align: top;
      table{
          margin-top: 3px;
          tr{
              line-height: 26px;
          }
          td{
              padding: 0 30px 0 0;
          }
      }
  }
  .seize {
    height: 20px;
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
    margin-top: 35px;
  }
}
</style>
<style lang="less">
.memDetails {
  .el-row {
    margin-bottom: 12px;
  }
  label {
    // width: 120px;
    text-align: left;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .btnOptions {
    text-align: center;
    margin-top: 50px;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/memDetails.vue